import { z } from "zod";

import { splitByCharacterCountStrategySchema } from "./enums";

const splitByCharacterCountTargetSchema = z.object({
	id: z.string(),
	length: z.number().optional(),
	start: z.number().optional(),
	target: z.string().optional(),
	strategy: splitByCharacterCountStrategySchema.optional(),
});
export type SplitByCharacterCountTarget = z.infer<typeof splitByCharacterCountTargetSchema>;

export const splitStringByCharacterCountConfigurationSchema = z.object({
	sourceField: z.string(),
	targets: z.array(splitByCharacterCountTargetSchema),
});

const splitStringByDelimiterTargetSchema = z.object({
	id: z.string(),
	target: z.string().optional(),
});
export type SplitStringByDelimiterTarget = z.infer<typeof splitStringByDelimiterTargetSchema>;

export const splitStringByDelimiterConfigurationSchema = z.object({
	sourceField: z.string(),
	delimiter: z.string(),
	targets: z.array(splitStringByDelimiterTargetSchema),
});
export type SplitStringByDelimiterConfiguration = z.infer<typeof splitStringByDelimiterConfigurationSchema>;
